import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import { CACHE_REVALIDATE_24H } from "../../../utils/constants";
import fetchUtil from "../../../utils/fetchUtil";
import AlliedServices from "../../../components/AlliedServices/AlliedServices";
import ErrorComponent from "../../../components/ErrorComponent";
import { MetaTagsComp } from "../../../components/MetaTagsComp";
import { useEffect } from "react";

const AlliedServicesDetail: NextPage = (props: any) => {
  if (!props.pageData || props.pageData.length === 0) {
    return <ErrorComponent />;
  }

  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty("--navbar-color", "#6c48f0");
    customStyle.setProperty("--navbar-menu-color", "#FFFFFF");
  }, []);

  const meta = props.pageData[0]?.meta;

  return (
    <>
      {meta && (
        <MetaTagsComp {...meta} canonicalUrl={`${process.env.NEXT_PUBLIC_BASE_URL}/student-services/allied-services/${props.slug}`} />
      )}
      <AlliedServices {...props} />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: "blocking" };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const slug = context.params?.slug as string;
  const pageData: any = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/allied-services?slug=${slug}`, 'GET', {}, '', false)
  const alliedServicesCardData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/allied-services/cards`, 'GET', {}, '', false)
  const countriesList = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/vendors/countries`, 'GET', {}, '', false)

  return {
    props: {
      pageData,
      alliedServicesCardData,
      countriesList,
      slug
    },
    revalidate: CACHE_REVALIDATE_24H,
  };
};

export default AlliedServicesDetail;
